<template>
  <div class="fp-preferences-content">
    <div class="second-step">
      <div>
        <div>
          <h6>
            {{ $lang.messages.preferences_payment_title }}
          </h6>
          <p>
           {{ $lang.messages.preferences_payments_text }}
          </p>
          <div class="choices">
            <label class="checkbox-wrapper">
              <input type="checkbox" v-model="alimonyChecked">
              <span class="checkmark"></span>
              {{ $lang.messages.spousalMaintenance }}
            </label>
            <div>
              <label class="radio-wrapper" :class="{'disabled' : !alimonyChecked}" :disabled="!alimonyChecked">
                <input type="radio" name="spousalMaintenance" v-model="alimony" value="paying">
                <span class="radio-checkmark"></span>
                <span class="radio-label">{{ $lang.messages.preferences_payments_paying }}</span>
              </label>

              <label class="radio-wrapper" :class="{'disabled' : !alimonyChecked}" :disabled="!alimonyChecked">
                <input type="radio" name="spousalMaintenance" v-model="alimony" value="receiving">
                <span class="radio-checkmark"></span>
                <span class="radio-label">{{ $lang.messages.preferences_payments_receiving }}</span>
              </label>
            </div>
          </div>
          <div class="choices">
            <label class="checkbox-wrapper">
              <input type="checkbox" v-model="childSupportChecked">
              <span class="checkmark"></span>
              {{ $lang.messages.childMaintenance }}
            </label>
            <div>
              <label class="radio-wrapper" :class="{'disabled' : !childSupportChecked}" :disabled="!childSupportChecked">
                <input type="radio" name="childMaintenance" v-model="childSupport" value="paying">
                <span class="radio-checkmark"></span>
                <span class="radio-label">{{ $lang.messages.preferences_payments_paying }}</span>
              </label>
              <label class="radio-wrapper" :class="{'disabled' : !childSupportChecked}" :disabled="!childSupportChecked">
                <input type="radio" name="childMaintenance" v-model="childSupport" value="receiving">
                <span class="radio-checkmark"></span>
                <span class="radio-label">{{ $lang.messages.preferences_payments_receiving }}</span>
              </label>
            </div>
          </div>
          <div class="choices">
            <label class="checkbox-wrapper">
              <input type="checkbox" v-model="sharedExpensesChecked">
              <span class="checkmark"></span>
              <span class="radio-label">{{ $lang.messages.sharedExpense }}</span>
            </label>
          </div>
        </div>
        <img class="illustration img-fluid" src='@/assets/images/preferences_illustration_card.png' />
      </div>
      <p>
        {{ $lang.messages.preferences_payments_alimony_child_description }}
      </p>
      <p>
        {{ $lang.messages.preferences_payments_shared_expenses_description }}
      </p>
    </div>
    <button type="button" class="generic-btn back-btn" @click="backButtonClick">
        <span>
          {{ $lang.messages.back }}
        </span>
    </button>
    <button type="button" class="action-btn next-btn" @click="nextButtonClick">
        <span>
          {{ $lang.messages.preferences_next }}
        </span>
    </button>
  </div>
</template>
<script>
  import { mapActions } from "vuex";
  import { POST_PAYMENTS_PREFERENCES, GET_PREFERENCES, SET_PAYMENT_PREFERENCE_COMPLETED } from "@/store/action.types";
  
  export default {
    name: "PreferencesPayments",
    props: {
      backButtonClick: {
        type: Function,
        required: true
      },
    },
    data() {
      return {
        alimonyChecked: false,
        alimony: 'paying',
        childSupportChecked: false,
        childSupport: 'paying',
        sharedExpensesChecked: false,
      }
    },
    computed: {
      paymentPreferenceCompleted() {
        return this.$store.getters.paymentPreferenceCompleted
      },
      parentingSchedulePreferenceCompleted() {
        return this.$store.getters.parentingSchedulePreferenceCompleted
      },
    },
    /**
     * @description Method checks if payment preferences are completed
     * If they are completed, it maps response data to component data
     */
    mounted() {
      if (this.paymentPreferenceCompleted) {
        this.getPreferencesAction()
            .then(response => {
              const data = response.data.data;
              if (data.alimonyPaying) {
                this.alimonyChecked = true;
                this.alimony = 'paying';
              }
              if (data.alimonyReceiving) {
                this.alimonyChecked = true;
                this.alimony = 'receiving';
              }
              if (data.childSupportPaying) {
                this.childSupportChecked = true;
                this.childSupport = 'paying';
              }
              if (data.childSupportReceiving) {
                this.childSupportChecked = true;
                this.childSupport = 'receiving';
              }
              if (data.sharedExpenses) {
                this.sharedExpensesChecked = true;
              }
            })
            .catch(() => {
              this.$snotify.error(this.$lang.messages.sn_genericError, 'ERROR');
            });
      }
    },
    methods: {
      ...mapActions({
        paymentsPreferencesAction: POST_PAYMENTS_PREFERENCES,
        getPreferencesAction: GET_PREFERENCES,
        setPaymentsPreferencesAction: SET_PAYMENT_PREFERENCE_COMPLETED
      }),
      /**
       * @description Method checks if payment preferences are completed
       * If they aren't, it sends request to API to save them and emits nextButtonClick, to show next screen
       * If they are completed, it only emits nextButtonClick, to show next screen
       */
      nextButtonClick() {
        this.paymentsPreferencesAction({
          alimonyPaying: this.alimonyChecked && this.alimony === 'paying',
          alimonyReceiving: this.alimonyChecked && this.alimony === 'receiving',
          childSupportPaying: this.childSupportChecked && this.childSupport === 'paying',
          childSupportReceiving: this.childSupportChecked && this.childSupport === 'receiving',
          sharedExpenses: this.sharedExpensesChecked,
        })
        .then(() => {
          this.$emit("nextButtonClick");
          this.setPaymentsPreferencesAction(true);
        })
        .catch(() => {
          this.$snotify.error(this.$lang.messages.sn_genericError, 'ERROR');
        });
        this.$emit("nextButtonClick");
      },
    }
  }
</script>

